module.exports = __webpack_public_path__ + "img/threeday1-1.788530d7.jpg";